import styles from './styles.module.scss';
import { TimedEventItem } from './TimedEventItem';
import { useTranslation } from 'react-i18next';
import type { TimedEvent } from '@game-libs/timed-events-orchestrator';
import { useTimedEventsStore } from '../../store/zustand/useTimedEventsStore';

export const TimedEvents = () => {
  const { t } = useTranslation('infos');
  const timedEvents = useTimedEventsStore((s) => s.events);

  // Filter for unfinished events only
  const unfinishedEvents = timedEvents.filter((event: TimedEvent) => !event.done);

  return (
    <div className={styles.timedEventsContainer}>
      <div className={styles.itemsBanner}>{t('banner.events')}</div>
      {unfinishedEvents.map((event: TimedEvent) => (
        <TimedEventItem
          key={event.id}
          iconId={event.iconId}
          categoryId={event.categoryId}
          eventId={event.id}
          current={event.elapsed}
          max={event.duration}
          paused={event.paused || false}
        />
      ))}
    </div>
  );
};
